import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TimeService {
  private apiUrl = `${environment.apiUrl}/programacion-masiva`;

  constructor(private http: HttpClient) { }

  getServerTime(): Observable<{ serverTime: Date }> {
    // Apuntamos al nuevo endpoint que creamos en el backend
    return this.http.get<{ serverTime: Date }>(`${this.apiUrl}/server-time`);
  }
}